/*
 * ICOFFEE cart: drawer + cart page on Shopify's Ajax Cart API.
 * Every change asks Shopify to re-render the cart sections ([data-ic-cart-root]) and swaps their
 * [data-ic-cart-view], so prices, discounts and the free-shipping bar always come from Liquid.
 * Public API: window.IcCart.add(items, { open }), .change(key, qty), .open(), .close(), .refresh()
 * An item may carry line properties; Build Your Own Bundle uses "_bundle" so its coffees show as one bundle.
 */
(function () {
  'use strict';

  var cfgEl = document.getElementById('IcCartConfig');
  if (!cfgEl || window.IcCart) return;
  var cfg = JSON.parse(cfgEl.textContent);
  var t = cfg.strings || {};
  var drawer = document.getElementById('IcCartDrawer');
  var isCartPage = cfg.cartPage === 'cart';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  var queue = Promise.resolve();
  var openPanels = {};
  var qtyTimers = {};
  var noteTimer = null;
  var notePending = null;
  var lastTrigger = null;

  /* ---------- requests ---------- */

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('[data-ic-cart-root]').forEach(function (root) {
      if (ids.indexOf(root.dataset.sectionId) < 0) ids.push(root.dataset.sectionId);
    });
    return ids;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          var err = new Error(data.description || data.message || 'cart_error');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function withSections(body) {
    body.sections = sectionIds().join(',');
    body.sections_url = location.pathname;
    return body;
  }

  // run cart mutations one at a time so responses can't arrive out of order
  function run(task) {
    var p = queue.then(task);
    queue = p.catch(function () {});
    return p;
  }

  /* ---------- rendering ---------- */

  function render(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      var root = document.querySelector('[data-ic-cart-root][data-section-id="' + id + '"]');
      if (!html || !root) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-ic-cart-root][data-section-id="' + id + '"] [data-ic-cart-view]');
      var old = root.querySelector('[data-ic-cart-view]');
      if (!fresh || !old) return;

      var active = document.activeElement;
      var focusKey = active && root.contains(active) ? active.getAttribute('data-ic-focus') : null;
      var scroller = root.querySelector('[data-ic-scroll]');
      var scrollTop = scroller ? scroller.scrollTop : 0;
      var viewTop = old.scrollTop;
      var carousels = {};
      root.querySelectorAll('[data-ic-carousel]').forEach(function (c) {
        var track = c.querySelector('[data-ic-carousel-track]');
        if (track) carousels[c.dataset.icCarousel] = track.scrollLeft;
      });
      var note = root.querySelector('[data-ic-note]');
      var noteValue = note && notePending !== null ? note.value : null;

      old.replaceWith(fresh);
      if (viewTop) fresh.scrollTop = viewTop;

      var newScroller = root.querySelector('[data-ic-scroll]');
      if (newScroller) newScroller.scrollTop = scrollTop;
      root.querySelectorAll('[data-ic-carousel]').forEach(function (c) {
        var track = c.querySelector('[data-ic-carousel-track]');
        if (track && carousels[c.dataset.icCarousel] != null) track.scrollLeft = carousels[c.dataset.icCarousel];
      });
      if (noteValue !== null) {
        var newNote = root.querySelector('[data-ic-note]');
        if (newNote) newNote.value = noteValue;
      }
      restorePanels(root, true);
      initCarousels(root);
      if (focusKey) {
        var target = root.querySelector('[data-ic-focus="' + cssEscape(focusKey) + '"]');
        if (target) target.focus({ preventScroll: true });
        else focusFallback(root);
      }
    });
    syncCount();
    syncCards();
  }

  /* ---------- product cards: once a product is in the cart its Add To Cart turns into a − / + stepper ---------- */

  // what's in the cart, read from the drawer's server-rendered lines: variant id -> { key, qty }
  function cartLines() {
    var lines = {};
    if (!drawer) return lines;
    drawer.querySelectorAll('.ic-line[data-variant]').forEach(function (li) {
      lines[li.dataset.variant] = { key: li.dataset.key, qty: Number(li.dataset.qty) };
    });
    return lines;
  }

  function cardSlots() {
    return Array.prototype.filter.call(document.querySelectorAll('form[action$="/cart/add"]'), function (form) {
      return !form.closest('product-form-component, #IcCartDrawer, [data-ic-cart-root]') && !form.hasAttribute('data-ic-native');
    });
  }

  function makeStepper() {
    var wrap = document.createElement('div');
    wrap.className = 'ic-cslot';
    wrap.setAttribute('data-ic-line', '');
    wrap.innerHTML =
      '<div class="ic-qty" role="group">' +
      '<button type="button" class="ic-qty__btn ic-qty__btn--minus" data-ic-qty="-1"></button>' +
      '<span class="ic-qty__value" data-ic-qty-value aria-live="polite"></span>' +
      '<button type="button" class="ic-qty__btn ic-qty__btn--plus" data-ic-qty="1"></button>' +
      '</div>';
    var icons = drawer && drawer.querySelector('.ic-line .ic-qty');
    if (icons) {
      wrap.querySelector('.ic-qty__btn--minus').innerHTML = icons.querySelector('.ic-qty__btn--minus').innerHTML;
      wrap.querySelector('.ic-qty__btn--plus').innerHTML = icons.querySelector('.ic-qty__btn--plus').innerHTML;
    } else {
      wrap.querySelector('.ic-qty__btn--minus').textContent = '−';
      wrap.querySelector('.ic-qty__btn--plus').textContent = '+';
    }
    wrap.querySelector('.ic-qty__btn--minus').setAttribute('aria-label', t.decrease || '−');
    wrap.querySelector('.ic-qty__btn--plus').setAttribute('aria-label', t.increase || '+');
    return wrap;
  }

  function syncCards() {
    var lines = cartLines();
    cardSlots().forEach(function (form) {
      var input = form.querySelector('[name="id"]');
      var line = input && lines[input.value];
      var slot = form.querySelector(':scope > .ic-cslot');
      if (!line) {
        if (slot) {
          var hadFocus = slot.contains(document.activeElement);
          slot.remove();
          form.classList.remove('is-in-cart');
          if (hadFocus) {
            var btn = form.querySelector('[type="submit"]');
            if (btn) btn.focus({ preventScroll: true });
          }
        }
        return;
      }
      if (!slot) {
        slot = makeStepper();
        form.appendChild(slot);
      }
      form.classList.add('is-in-cart');
      slot.dataset.key = line.key;
      slot.dataset.qty = line.qty;
      delete slot.dataset.pendingQty;
      slot.classList.remove('is-pending');
      slot.querySelector('[data-ic-qty-value]').textContent = line.qty;
    });
  }

  function focusFallback(root) {
    var el = root.querySelector('.ic-qty__btn, .ic-cempty__cta, [data-ic-cart-close]') || (drawer && drawer.querySelector('[data-ic-cart-close]'));
    if (el) el.focus({ preventScroll: true });
  }

  function cssEscape(value) {
    return window.CSS && CSS.escape ? CSS.escape(value) : String(value).replace(/["\\]/g, '\\$&');
  }

  function currentCount() {
    var view = document.querySelector('[data-ic-cart-view][data-count]');
    return view ? Number(view.dataset.count) || 0 : 0;
  }

  function syncCount() {
    var count = currentCount();
    document.querySelectorAll('[data-ic-cart-count]').forEach(function (el) {
      var before = el.textContent;
      el.textContent = count > 99 ? '99+' : String(count);
      el.hidden = count === 0;
      if (before !== el.textContent && count > 0 && !reduce.matches) {
        el.classList.remove('is-bumped');
        void el.offsetWidth;
        el.classList.add('is-bumped');
      }
    });
    document.querySelectorAll('[data-ic-cart-open]').forEach(function (el) {
      if (el.dataset.labelTemplate) el.setAttribute('aria-label', el.dataset.labelTemplate.replace('{{ count }}', count));
    });
  }

  function announce(message) {
    var live = drawer && drawer.querySelector('[data-ic-cart-status]');
    if (!live || !message) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = message; }, 60);
  }

  function setBusy(on) {
    document.querySelectorAll('[data-ic-cart-view]').forEach(function (v) {
      if (on) v.setAttribute('aria-busy', 'true');
      else v.removeAttribute('aria-busy');
    });
  }

  function toast(message, tone) {
    if (window.IcAccount && window.IcAccount.toast) window.IcAccount.toast(message, { tone: tone || 'error' });
    else announce(message);
  }

  function fail(err) {
    var msg = err && err.data && (err.data.description || err.data.message);
    toast(msg && typeof msg === 'string' ? msg : t.error, 'error');
    return refresh();
  }

  function refresh() {
    var ids = sectionIds();
    if (!ids.length) return Promise.resolve();
    return fetch(location.pathname + '?sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  /* ---------- cart actions ---------- */

  function add(items, opts) {
    opts = opts || {};
    var lines = (items || [])
      .filter(function (i) { return i && i.id; })
      .map(function (i) {
        var line = { id: Number(i.id), quantity: Number(i.quantity) || 1 };
        if (i.properties) line.properties = i.properties;
        return line;
      });
    if (!lines.length) return Promise.resolve(null);
    return run(function () {
      setBusy(true);
      return post(cfg.routes.add, withSections({ items: lines }))
        .then(function (data) {
          render(data.sections);
          announce(t.added);
          if (opts.open !== false && !isCartPage) open();
          document.dispatchEvent(new CustomEvent('ic:cart:change', { detail: { action: 'add', items: data.items } }));
          return data;
        })
        .finally(function () { setBusy(false); });
    }).catch(function (err) {
      fail(err);
      throw err;
    });
  }

  function change(key, quantity) {
    return run(function () {
      setBusy(true);
      return post(cfg.routes.change, withSections({ id: key, quantity: quantity }))
        .then(function (cart) {
          render(cart.sections);
          announce(quantity === 0 ? t.removed : t.updated);
          document.dispatchEvent(new CustomEvent('ic:cart:change', { detail: { action: 'change', cart: cart } }));
          return cart;
        })
        .catch(fail)
        .finally(function () { setBusy(false); });
    });
  }

  function saveNote(value) {
    notePending = value;
    return run(function () {
      return post(cfg.routes.update, { note: value })
        .then(function () {
          if (notePending === value) notePending = null;
          var status = document.querySelector('[data-ic-note-status]');
          if (status) status.textContent = t.note_saved;
        })
        .catch(function () { toast(t.error); });
    });
  }

  function applyCodes(codes, attempted, form) {
    return run(function () {
      setBusy(true);
      var button = form && form.querySelector('.ic-coupon__apply');
      if (button) button.setAttribute('aria-busy', 'true');
      return post(cfg.routes.update, withSections({ discount: codes.join(',') }))
        .then(function (cart) {
          var bad = attempted && (cart.discount_codes || []).some(function (d) {
            return d.code.toLowerCase() === attempted.toLowerCase() && !d.applicable;
          });
          if (bad) {
            // drop the code that didn't stick, keep the rest, then show the error under the field
            var keep = codes.filter(function (c) { return c.toLowerCase() !== attempted.toLowerCase(); });
            return post(cfg.routes.update, withSections({ discount: keep.join(',') })).then(function (fixed) {
              render(fixed.sections);
              document.querySelectorAll('[data-ic-coupon-error]').forEach(function (e) {
                var f = e.closest('[data-ic-panel]');
                if (f && f.classList.contains('is-open')) e.hidden = false;
              });
              var input = document.querySelector('[data-ic-panel].is-open .ic-coupon__input');
              if (input) {
                input.value = attempted;
                input.focus({ preventScroll: true });
                input.select();
              }
            });
          }
          render(cart.sections);
          if (attempted) announce(t.coupon_applied);
        })
        .catch(fail)
        .finally(function () {
          setBusy(false);
          if (button) button.removeAttribute('aria-busy');
        });
    });
  }

  /* ---------- drawer ---------- */

  var closeTimer = 0;
  var onCloseEnd = null;

  // stop a close that is still animating (e.g. Add To Cart pressed while the drawer slides out)
  function cancelClose() {
    clearTimeout(closeTimer);
    if (onCloseEnd) drawer.querySelector('.ic-cd__panel').removeEventListener('animationend', onCloseEnd);
    onCloseEnd = null;
    drawer.classList.remove('is-closing');
  }

  function lockScroll(on) {
    var html = document.documentElement;
    if (on) {
      // keep the page from shifting sideways when its scrollbar disappears
      var gap = window.innerWidth - html.clientWidth;
      html.style.setProperty('--ic-sbw', gap > 0 ? gap + 'px' : '0px');
      html.classList.add('ic-cd-lock');
    } else {
      html.classList.remove('ic-cd-lock');
      html.style.removeProperty('--ic-sbw');
    }
  }

  function open() {
    if (!drawer) return;
    if (drawer.classList.contains('is-closing')) cancelClose();
    if (drawer.open) return;
    lockScroll(true);
    drawer.showModal();
    setExpanded(true);
    initCarousels(drawer);
    var close = drawer.querySelector('[data-ic-cart-close]');
    if (close) close.focus({ preventScroll: true });
  }

  function close() {
    if (!drawer || !drawer.open || drawer.classList.contains('is-closing')) return;
    if (reduce.matches) return drawer.close();
    var panel = drawer.querySelector('.ic-cd__panel');
    // hide the dialog first and drop the class after, otherwise the panel snaps back and replays its open animation
    var finish = function () {
      drawer.close();
      cancelClose();
    };
    onCloseEnd = function (e) {
      if (e.target === panel) finish();
    };
    panel.addEventListener('animationend', onCloseEnd);
    closeTimer = setTimeout(finish, 450);
    drawer.classList.add('is-closing');
  }

  function setExpanded(on) {
    document.querySelectorAll('[data-ic-cart-open]').forEach(function (el) {
      if (el.hasAttribute('aria-expanded')) el.setAttribute('aria-expanded', String(on));
    });
  }

  if (drawer) {
    drawer.addEventListener('close', function () {
      if (drawer.classList.contains('is-closing')) cancelClose();
      lockScroll(false);
      setExpanded(false);
      if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
      lastTrigger = null;
    });
    drawer.addEventListener('cancel', function (e) {
      e.preventDefault();
      close();
    });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) close();
    });
  }

  /* ---------- folding panels (note / coupon / promo) ---------- */

  function setPanel(root, name, on, instant) {
    var panel = root.querySelector('[data-ic-panel="' + name + '"]');
    var toggle = root.querySelector('[data-ic-panel-toggle="' + name + '"]');
    if (!panel) return;
    if (instant) panel.style.transition = 'none';
    panel.classList.toggle('is-open', on);
    panel.inert = !on;
    if (toggle) toggle.setAttribute('aria-expanded', String(on));
    if (instant) {
      void panel.offsetHeight;
      panel.style.transition = '';
    }
  }

  function restorePanels(root, instant) {
    Object.keys(openPanels).forEach(function (name) {
      if (openPanels[name]) setPanel(root, name, true, instant);
    });
  }

  /* ---------- carousels ---------- */

  function initCarousels(scope) {
    scope.querySelectorAll('[data-ic-carousel]').forEach(function (c) {
      var track = c.querySelector('[data-ic-carousel-track]');
      if (!track) return;
      if (!track.icBound) {
        track.icBound = true;
        var raf = 0;
        track.addEventListener('scroll', function () {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () { updateCarousel(c); });
        }, { passive: true });
      }
      updateCarousel(c);
    });
  }

  function updateCarousel(c) {
    var track = c.querySelector('[data-ic-carousel-track]');
    var slides = track.querySelectorAll('[data-ic-slide]');
    if (!slides.length) return;
    var step = slides.length > 1 ? Math.abs(slides[1].offsetLeft - slides[0].offsetLeft) : track.clientWidth;
    var pos = Math.abs(track.scrollLeft);
    var max = track.scrollWidth - track.clientWidth;
    var index = step ? Math.round(pos / step) : 0;
    var prev = c.querySelector('[data-ic-carousel-prev]');
    var next = c.querySelector('[data-ic-carousel-next]');
    if (prev) prev.disabled = pos <= 2;
    if (next) next.disabled = pos >= max - 2;
    var dots = c.querySelectorAll('[data-ic-carousel-dots] span');
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === Math.min(index, dots.length - 1)); });
    slides.forEach(function (s, i) {
      if (s.hasAttribute('aria-roledescription')) s.setAttribute('aria-label', (t.slide || '').replace('{{ index }}', i + 1).replace('{{ total }}', slides.length));
    });
  }

  function slideBy(c, dir) {
    var track = c.querySelector('[data-ic-carousel-track]');
    var rtl = getComputedStyle(track).direction === 'rtl';
    track.scrollBy({ left: dir * (rtl ? -1 : 1) * track.clientWidth, behavior: reduce.matches ? 'auto' : 'smooth' });
  }

  /* ---------- quantity ---------- */

  function stepQty(line, delta) {
    var key = line.dataset.key;
    var current = Number(line.dataset.pendingQty || line.dataset.qty);
    var next = Math.max(0, current + delta);
    if (next === current) return;
    line.dataset.pendingQty = next;
    line.querySelectorAll('[data-ic-qty-value], [data-ic-qty-meta]').forEach(function (el) { el.textContent = next; });
    line.classList.add('is-pending');
    clearTimeout(qtyTimers[key]);
    if (next === 0) return removeLine(line);
    qtyTimers[key] = setTimeout(function () { change(key, next); }, 320);
  }

  // slide a line out while Shopify removes it
  function collapse(line) {
    if (reduce.matches) return;
    line.style.height = line.offsetHeight + 'px';
    line.style.overflow = 'hidden';
    line.classList.add('is-removing');
    requestAnimationFrame(function () {
      line.style.transition = 'height .3s cubic-bezier(.23,1,.32,1) .12s, padding .3s ease .12s, opacity .2s ease, transform .25s ease';
      line.style.height = '0px';
      line.style.paddingBlock = '0px';
    });
  }

  function removeLine(line) {
    var key = line.dataset.key;
    clearTimeout(qtyTimers[key]);
    if (line.classList.contains('ic-line')) collapse(line);
    return change(key, 0);
  }

  // a Build Your Own Bundle leaves the cart whole: all its coffees in one request
  function removeBundle(line) {
    var updates = {};
    (line.dataset.keys || '').split(',').filter(Boolean).forEach(function (key) { updates[key] = 0; });
    if (!Object.keys(updates).length) return;
    collapse(line);
    return run(function () {
      setBusy(true);
      return post(cfg.routes.update, withSections({ updates: updates }))
        .then(function (cart) {
          render(cart.sections);
          announce(t.removed);
          document.dispatchEvent(new CustomEvent('ic:cart:change', { detail: { action: 'change', cart: cart } }));
        })
        .catch(fail)
        .finally(function () { setBusy(false); });
    });
  }

  /* ---------- add buttons ---------- */

  function flashAdded(button) {
    if (!button) return;
    var label = button.querySelector('span');
    var text = button.dataset.added;
    button.classList.add('is-added');
    if (label && text) {
      var original = label.textContent;
      label.textContent = text;
      setTimeout(function () {
        button.classList.remove('is-added');
        label.textContent = original;
      }, 1600);
    } else {
      setTimeout(function () { button.classList.remove('is-added'); }, 1600);
    }
  }

  function addFrom(button, items) {
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    add(items)
      .then(function () {
        if (document.contains(button)) flashAdded(button);
      })
      .catch(function () {})
      .finally(function () { button.removeAttribute('aria-busy'); });
  }

  /* ---------- events ---------- */

  document.addEventListener('click', function (e) {
    // a size pill swaps the card's variant: show Add To Cart or the stepper for the new size
    if (e.target.closest('.ic-bs-card__size')) setTimeout(syncCards, 0);

    var opener = e.target.closest('[data-ic-cart-open]');
    if (opener) {
      if (isCartPage || !drawer) return;
      e.preventDefault();
      lastTrigger = opener;
      open();
      return;
    }

    var closer = e.target.closest('[data-ic-cart-close]');
    if (closer && drawer && drawer.contains(closer)) {
      e.preventDefault();
      close();
      return;
    }

    var qty = e.target.closest('[data-ic-qty]');
    if (qty) {
      var line = qty.closest('[data-ic-line]');
      if (line) stepQty(line, Number(qty.dataset.icQty));
      return;
    }

    var bundleRemove = e.target.closest('[data-ic-bundle-remove]');
    if (bundleRemove) {
      var bundleLine = bundleRemove.closest('[data-ic-bundle-line]');
      if (bundleLine) removeBundle(bundleLine);
      return;
    }

    var remove = e.target.closest('[data-ic-remove]');
    if (remove) {
      var rl = remove.closest('[data-ic-line]');
      if (rl) removeLine(rl);
      return;
    }

    var addBtn = e.target.closest('[data-ic-add]');
    if (addBtn) {
      e.preventDefault();
      addFrom(addBtn, [{ id: addBtn.dataset.icAdd, quantity: 1 }]);
      return;
    }

    var toggle = e.target.closest('[data-ic-panel-toggle]');
    if (toggle) {
      var root = toggle.closest('[data-ic-cart-root]');
      var name = toggle.dataset.icPanelToggle;
      var on = toggle.getAttribute('aria-expanded') !== 'true';
      // note and coupon share the drawer's pink box, so only one is open at a time
      if (on && (name === 'note' || name === 'coupon')) {
        var other = name === 'note' ? 'coupon' : 'note';
        openPanels[other] = false;
        setPanel(root, other, false);
      }
      openPanels[name] = on;
      setPanel(root, name, on);
      if (on) {
        var field = root.querySelector('[data-ic-panel="' + name + '"] textarea, [data-ic-panel="' + name + '"] input');
        if (field) setTimeout(function () { field.focus({ preventScroll: true }); }, 60);
      }
      return;
    }

    var codeRemove = e.target.closest('[data-ic-code-remove]');
    if (codeRemove) {
      var form = codeRemove.closest('[data-ic-cart-root]').querySelector('[data-ic-coupon-form]');
      var codes = existingCodes(form).filter(function (c) { return c !== codeRemove.dataset.icCodeRemove; });
      applyCodes(codes, null, form);
      return;
    }

    var prev = e.target.closest('[data-ic-carousel-prev]');
    var next = e.target.closest('[data-ic-carousel-next]');
    if (prev || next) {
      slideBy((prev || next).closest('[data-ic-carousel]'), prev ? -1 : 1);
    }
  });

  function existingCodes(form) {
    return ((form && form.dataset.codes) || '').split(',').filter(Boolean);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;

    if (form.matches('[data-ic-coupon-form]')) {
      e.preventDefault();
      var input = form.querySelector('input[name="discount"]');
      var code = input.value.trim();
      var error = form.querySelector('[data-ic-coupon-error]');
      if (error) error.hidden = true;
      if (!code) return input.focus();
      var codes = existingCodes(form);
      if (codes.some(function (c) { return c.toLowerCase() === code.toLowerCase(); })) {
        input.value = '';
        return;
      }
      applyCodes(codes.concat(code), code, form);
      return;
    }

    if (form.matches('[data-ic-checkout]')) {
      // the ICOFFEE checkout pages take over from Shopify's checkout while their preview is on (snippets/ic-checkout-url)
      var custom = cfg.checkoutUrl && cfg.checkoutUrl !== '/checkout';
      // make sure a note that's still being typed reaches the order
      var note = document.querySelector('[data-ic-note]');
      if (note && notePending !== null) {
        e.preventDefault();
        clearTimeout(noteTimer);
        var submitter = e.submitter;
        saveNote(note.value).then(function () {
          if (submitter) submitter.setAttribute('aria-busy', 'true');
          if (custom) {
            location.href = cfg.checkoutUrl;
            return;
          }
          var hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'checkout';
          form.appendChild(hidden);
          form.submit();
        });
      } else if (custom) {
        e.preventDefault();
        location.href = cfg.checkoutUrl;
      }
      return;
    }

    // theme product forms (featured slider, best sellers): add over Ajax and show the drawer
    var action = form.getAttribute('action') || '';
    if (/\/cart\/add(\.js)?$/.test(action.split('?')[0]) && !form.closest('product-form-component') && !form.hasAttribute('data-ic-native')) {
      e.preventDefault();
      var data = new FormData(form);
      var button = e.submitter || form.querySelector('[type="submit"]');
      addFrom(button, [{ id: data.get('id'), quantity: data.get('quantity') || 1 }]);
    }
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-ic-note]')) return;
    var value = e.target.value;
    notePending = value;
    var status = document.querySelector('[data-ic-note-status]');
    if (status) status.textContent = '';
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { saveNote(value); }, 700);
  });

  // another tab or Horizon code changed the cart: re-sync when the page becomes visible again
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refresh();
  });

  /* ---------- card payments: the cart is kept until Shopify confirms the payment ---------- */

  // The checkout pages send card shoppers to Shopify's payment page and leave a note here (ic:payment).
  // On the next visit the ICOFFEE app says whether that payment went through; only then is the cart emptied.
  (function settlePayment() {
    var KEY = 'ic:payment';
    var pending = null;
    try { pending = JSON.parse(localStorage.getItem(KEY)); } catch (err) {}
    if (!pending || !pending.draft) return;
    var forget = function () { try { localStorage.removeItem(KEY); } catch (err) {} };
    if (Date.now() - pending.at > 3 * 864e5) return forget();
    post('/apps/icoffee/checkout/status', { draft: pending.draft, token: pending.token })
      .then(function (data) {
        if (data.payment === 'gone') return forget();
        if (data.payment !== 'completed') return;
        forget();
        return post(cfg.routes.cart + '/clear.js', {}).then(function () {
          toast((t.paid || '').replace('[order]', data.order || ''), 'success');
          return refresh();
        });
      })
      .catch(function () {});
  })();

  initCarousels(document);
  syncCount();
  syncCards();

  // replaces the cart's discount codes, redraws the cart and resolves with Shopify's cart (its discount_codes say
  // whether each code applies). assets/ic-loyalty.js puts a points reward on the cart and takes it off with it.
  function setCodes(codes) {
    return run(function () {
      setBusy(true);
      return post(cfg.routes.update, withSections({ discount: codes.join(',') }))
        .then(function (cart) {
          render(cart.sections);
          return cart;
        })
        .finally(function () { setBusy(false); });
    });
  }

  window.IcCart = { add: add, change: change, open: open, close: close, refresh: refresh, setCodes: setCodes };
})();
